<template>
    <div id='Game' ref="game_root">
        <div class="top">
            <div class="back" @click="back()"></div>
            <div class="null"></div>
            <div class="download_img"></div>
        </div>
        <div class="main1">
            <div class="img_area">
                <div class="show_img_area">
                    <img class="img" :src="play_item.big_img" alt="">

                    <div v-for="(item, key) in holes_list" :class="ring_class(item)" :key="key"
                        :style="get_pos_style(item)" @click="find_hole(item)"></div>

                </div>
            </div>
            <div class="swiper_tip"></div>
            <div class="swiper_tip2"></div>

        </div>

        <div class="main2">
            <div class="title">
                <div class="proc_img"></div>
                <div class="proc_txt">{{ proc_txt }}</div>
            </div>

            <!-- 请找出并点击8个明显不符合唐代的元素,已完成 -->
            <div class="holes_list">
                <Hole class="hole_item" v-for="(item, key) in holes_list" :key="key" :index="key" :item="item"
                    @click.native.stop="click_hole(key, item)">
                </Hole>
            </div>
            <div class="say_area">
                <div class="say_txt">{{ say_txt }}</div>
            </div>
            <audio ref="audioPlayer" :src="say_audio"></audio>
        </div>

    </div>
</template>

<script>
import vue from "vue";


import Hole from "./sub/Hole.vue";
export default vue.component('Game', {
    components: {
        Hole
    },
    data() {
        return {
            play_item: {},
            say_txt: '王上，细心一点就一定能找到的！',
            say_audio: '',
            holes_list: []

        }
    },
    created() {
        let image = new Image()
        this.holes_list = this.$game_config.get_play_holes(0)
    },
    mounted() {
    },
    methods: {
        ring_class(item) {
            var def = 'ring'
            item.high && (def += ' high')
            item.fat && (def += ' fat')
            item.pass && (def += ' on')

            return def
        },
        back() {
            var self = this
            if (!this.if_pass_all()) {

                var msg = {
                    title: '放弃本次勘图', con: '返回后,本个章节的勘图记录不会保存.您确定要返回嘛?',
                    type: 'two', cb: function () { self.$eventBus.$emit('back_main', this.item) }
                }
                this.$eventBus.$emit('show_dialog', msg)
                return
            }
            self.$eventBus.$emit('back_main', this.item)

        },
        init(play_item) {
            console.log(play_item)
            this.$set(this, 'play_item', play_item)
            this.holes_list = this.$game_config.get_play_holes(play_item.playid || 0)
            this.$refs['game_root'].scrollIntoView(true);
        },
        all_hole_def() {
            this.holes_list.forEach(i => { i.click_on = 0 });
        },
        click_hole(key, item) {
            console.log(item)
            if (!item.pass) { return }
            this.all_hole_def()
            // this.$set(this.holes_list[key], 'click_on', 1)
            item.click_on = 1
            this.show_say(item)

        },
        find_hole(item) {
            if (item.pass == 1) { return }

            item.pass = 1
            if (this.if_pass_all()) {

                var msg = { title: '通关成功', con: '王上慧眼如炬,明察秋毫!' }
                this.$eventBus.$emit('show_dialog', msg)

                console.log('通关')
                var args = Object.assign({}, this.play_item)

                this.$httpr.post("/pic_find_holes_guide/pass?r=" + Math.random(), args, (err, res) => {
                    if (err) { return console.log(err) }
                    console.log('成功')
                })
            }

        },
        if_pass_all() {
            var f = this.holes_list.find(i => i.pass == 0)
            return !f
        },
        play_audio(item) { //可支持播放语音 目前没有该需求
            console.log('play_audio')
            this.$refs.audioPlayer.pause(); //需要把之前的暂停

            this.say_audio = item.audio //替换src资源
            this.$refs.audioPlayer.load();  //加载资源

            this.$refs.audioPlayer.addEventListener('canplay', () => { //监听可以播放再执行play
                this.$refs.audioPlayer.play().catch(e => console.log("播放失败:", e));
            }, { once: true }); // 只监听一次

        },
        show_say(item) {
            console.log('show_say')
            this.say_txt = item.say
        },

        get_pos_style(item) {
            return { left: item.left + 'px', top: item.top + 'px' }
        },


    },
    computed: {
        get_pro_title() { },
        rest_time_txt() {
            return '11天3小时'
        },
        proc_txt() {
            var arr = this.holes_list.filter(i => i.pass)
            var all = this.holes_list.length
            var len = arr.length
            return `${len}/${all}`
        },

    }

})
</script>

<style scoped>
#Game {
    position: relative;
    width: 1080px;
    height: 2758px;
    /* display: flex;
    justify-content: center;
    align-items: center; */
    flex-direction: column;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/game/game_bg.png') no-repeat center;
    background-size: 100% auto;
    font-family: 'xique';
}

/*内容区域 从上到下 */
.top {
    z-index: 5;
    width: 1080px;
    height: 151px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/game/top_export.png') no-repeat center;
    background-size: 100% auto;
    position: absolute;
    display: flex;
}

.null {
    display: flex;
    flex: 1;
}

.top .back {
    /* border: 1px solid red; */
    width: 230px;
    height: 149px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/game/back.png') no-repeat 20%;
    background-size: 40%;
    /* 特殊图片，非设计稿加入，需要自己调整size */
}

.top .download_img {
    /* border: 1px solid red; */
    width: 230px;
    height: 149px;
}

.main1 {
    /* border: 1px solid red; */
    position: relative;
    width: 100%;
    height: 1676px;
    display: flex;
    flex-flow: column;
    align-items: center;
}

.main1 .swiper_tip {
    z-index: 1;
    position: absolute;
    width: 817px;
    height: 68px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/game/swiper_tip.png') no-repeat center;
    background-size: 100% auto;
    margin-top: 180px;

}

.main1 .swiper_tip2 {
    z-index: 1;
    position: absolute;
    width: 817px;
    height: 68px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/game/swiper_tip2.png') no-repeat center;
    background-size: 100% auto;
    margin-top: 180px;

}

.main1 .img_area {
    /* border: 1px solid red; */
    width: 100%;
    height: 1518px;
    overflow-x: auto;
    overflow-y: auto;
    margin-top: 148px;
}

.img_area .show_img_area {
    position: relative;
    height: 100%;
    /* width: 7020px; */
}

.img_area .img {
    position: absolute;
    height: 100%;
    width: auto;
    /* 兼容手机 */
    max-width: none !important;
}

.img_area .ring {
    z-index: 2;
    position: absolute;
    width: 200px;
    height: 200px;
    /* border: 8px solid black; */
    border-radius: 50%;
}

.ring.high {
    width: 230px;
    height: 280px;
}

.ring.fat {
    width: 300px;
}


.ring.on {
    border: 8px solid #fb0000;
    border-radius: 50%;
}


.main2 {
    /* border: 1px solid red; */
    position: relative;
    width: 100%;
    height: 1000px;
    display: flex;
    flex-flow: column;
    align-items: center;
}

.main2 .title {
    /* border: 1px solid red; */
    width: 100%;
    height: 95px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
}

.main2 .proc_img {
    width: 657px;
    height: 32px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/game/proc_title.png') no-repeat center;
    background-size: 100% auto;
}

.main2 .proc_txt {
    font-size: 48px;
    color: #a42423;
    margin-left: 9px;
}


.main2 .holes_list {
    /* border: 1px solid red; */
    width: 100%;
    height: 520px;
    margin-top: 2px;
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
    margin-top: 17px;

}

.holes_list .hole_item {
    margin: 20px 0px 0px 17px;
}

.main2 .say_area {
    position: relative;
    width: 724px;
    height: 225px;
    background: url('//whhxparty.ehijoy.com/img/whhx_party/pic_find_holes/guide/game/say_txt.png') no-repeat center;
    background-size: 100% auto;
    color: #643b26;
    font-size: 28px;
    margin-top: 34px;

}

.say_area .say_txt {
    /* border: 1px solid red; */
    width: 350px;
    height: 82px;
    position: absolute;
    left: 263px;
    top: 67px;
    line-height: 37px;
    display: flex;
    align-items: center;
}
</style>